export default __webpack_public_path__ + "static/media/LoginBgLogo.ddd65b90.svg";